module.exports = __webpack_public_path__ + "static/media/menu.206dea48.svg";